import { combineReducers } from 'redux';
import authReducer from './auth.reducers';

const reducer = combineReducers(Object.assign({
    authReducer
}));

export default reducer;